(function () {
  var MOBILE_MQ = window.matchMedia("(max-width: 767px)");

  function setActiveDevice(section, device) {
    var table = section.querySelector("[data-b2b-device-compare-table]");
    if (!table) return;

    table.classList.remove(
      "b2b-device-compare--device-a",
      "b2b-device-compare--device-b"
    );
    table.classList.add("b2b-device-compare--device-" + device);

    section.querySelectorAll("[data-b2b-device-tab]").forEach(function (tab) {
      var isActive = tab.getAttribute("data-b2b-device-tab") === device;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  }

  function clearToolbarState(section) {
    section.classList.remove(
      "is-toolbar-pinned",
      "is-toolbar-exited",
      "is-toolbar-before"
    );
  }

  function getToolbarOffset(section) {
    var toolbar = section.querySelector("[data-b2b-device-compare-toolbar]");
    if (!toolbar || !toolbar.offsetHeight) return 72;
    return toolbar.offsetHeight + 8;
  }

  function initToolbarPin(section) {
    var tableWrap = section.querySelector(".b2b-device-compare__table-wrap");
    if (!tableWrap) return;

    var rafId = 0;
    var boundUpdate = null;

    function updateToolbarPinState() {
      if (!MOBILE_MQ.matches) return;

      var rect = tableWrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var toolbarOffset = getToolbarOffset(section);

      clearToolbarState(section);

      /* Table not reached yet */
      if (rect.top >= vh) {
        section.classList.add("is-toolbar-before");
        return;
      }

      /* Table scrolled past — hide as soon as content ends, not whole section */
      if (rect.bottom <= toolbarOffset) {
        section.classList.add("is-toolbar-exited");
        return;
      }

      section.classList.add("is-toolbar-pinned");
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        updateToolbarPinState();
      });
    }

    function enableScrollPin() {
      if (boundUpdate) return;
      boundUpdate = scheduleUpdate;
      window.addEventListener("scroll", boundUpdate, { passive: true });
      window.addEventListener("resize", boundUpdate);
      scheduleUpdate();
    }

    function disableScrollPin() {
      if (boundUpdate) {
        window.removeEventListener("scroll", boundUpdate);
        window.removeEventListener("resize", boundUpdate);
        boundUpdate = null;
      }
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }
      clearToolbarState(section);
    }

    function syncToolbarPin() {
      if (MOBILE_MQ.matches) {
        enableScrollPin();
        return;
      }
      disableScrollPin();
    }

    syncToolbarPin();
    MOBILE_MQ.addEventListener("change", syncToolbarPin);
  }

  function syncMode(section) {
    if (MOBILE_MQ.matches) {
      var active = section.querySelector("[data-b2b-device-tab].is-active");
      var device = active
        ? active.getAttribute("data-b2b-device-tab")
        : "a";
      setActiveDevice(section, device);
      return;
    }

    var table = section.querySelector("[data-b2b-device-compare-table]");
    if (table) {
      table.classList.remove(
        "b2b-device-compare--device-a",
        "b2b-device-compare--device-b"
      );
    }
  }

  function initSection(section) {
    section.querySelectorAll("[data-b2b-device-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        if (!MOBILE_MQ.matches) return;
        setActiveDevice(section, tab.getAttribute("data-b2b-device-tab"));
      });
    });

    initToolbarPin(section);
    syncMode(section);
    MOBILE_MQ.addEventListener("change", function () {
      syncMode(section);
    });
  }

  function init() {
    document.querySelectorAll(".b2b-device-compare").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
